import React, { useEffect } from 'react';
import PropTypes, { number, bool } from 'prop-types';
import ProgressBar from '../../ProgressBar';

const SurveyProgressBar = ({
  current, total, researchConsentNeeded, setCurrentPage, setPageCount
}) => {
  const currentPageWithIntroduction = current + 1;
  const extraPageCount = researchConsentNeeded ? 3 : 2;
  const pageCount = total + extraPageCount;

  useEffect(() => {
    setCurrentPage(currentPageWithIntroduction);
    setPageCount(pageCount);
  }, [currentPageWithIntroduction, pageCount]);

  return (
    <ProgressBar
      current={currentPageWithIntroduction}
      total={pageCount}
    />
  );
};

const { func } = PropTypes;

SurveyProgressBar.propTypes = {
  current: number.isRequired,
  total: number.isRequired,
  researchConsentNeeded: bool.isRequired,
  setCurrentPage: func.isRequired,
  setPageCount: func.isRequired
};

export default SurveyProgressBar;
